import { Pill, Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import css from "./existingLeagueGroupsSummary.module.scss";

interface ExistingLeagueGroupsSummaryProps {
  groupCodes: string[];
}

const ExistingLeagueGroupsSummary = ({ groupCodes }: ExistingLeagueGroupsSummaryProps) => {
  const { t } = useTranslation();

  return (
    <div className={css.existingLeagueGroupsSummary}>
      <Text>{t("package-wizard.groups.linked-existing")}</Text>
      <div className={css.existingLeagueGroupsSummary_groups}>
        <Text type="sm">{t("package-wizard.groups.existing-groups")}</Text>
        {groupCodes.map(code => (
          <Pill key={code}>{code}</Pill>
        ))}
      </div>
    </div>
  );
};

export default ExistingLeagueGroupsSummary;
